<template>
  <div>
    <!-- 视频开始-->
    <div class="actModules">
      <h3 class="actModules_title" v-text="modulesTitle"></h3>
      <p class="actModules_descripe" v-text="modulesRules"></p>
      <div class="videoWrap">
        <div class="videoLayer" id="video"></div>
      </div>
    </div>
    <!-- 视频结束-->
  </div>
</template>

<script>
import './../../assets/css/reset.css';

export default {
	name: 'h5-video',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案',
			modulesRules: '规则描述',
			videoWidth: '视频宽度',
			videoHeight: '视频宽度',
			videoVid: '视频vid'
		}
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字'
		},
		modulesRules: {
			type: String,
			default: '规则描述'
		},
		videoWidth: {
			type: String,
			default: '730'
		},
		videoHeight: {
			type: String,
			default: '410'
		},
		videoVid: {
			type: String,
			default: 'x0839g6lwzn'
		}
	},
	data () {
		return {
			player: null,
			modulesTitle: '',
			modulesRules: '',
			posterShow: true
		};
	},
	mounted () {
		if (
			parseInt(this.videoWidth) <= 0 ||
      parseInt(this.videoHeight) <= 0 ||
      this.videoVid == ''
		) {
			return;
		}
		this.player = new window.Txplayer({
			containerId: 'video',
			vid: this.videoVid,
			width: this.videoWidth,
			height: this.videoHeight
		});
	},
	methods: {
		hidePoster: function () {
			this.posterShow = false;
			this.player.play();
		}
	}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "../../assets/scss/common.scss";
.videoWrap {
  width: 7.3rem;
  height: 4.1rem;
  margin: 0.2rem auto 0;
  @extend %relative;
  video {
    width: 100%;
    @extend %block;
  }
}

.videoLayer {
  width: 100%;
  height: 100%;
}

.videoPoster {
  width: 100%;
  @extend %block;
  @extend %absolute;
  left: 0;
  top: 0;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/qqVideo/h5Video.vue